import { API_JWT_BASE_URL } from '../http'

export const SEARCH_ASSETS_API = `${API_JWT_BASE_URL}/Assets/search`
export const GET_ASSET_DETAILS_API = `${API_JWT_BASE_URL}/Assets/details/`
export const EXPORT_ASSETS_API = `${API_JWT_BASE_URL}/Assets/export`
export const IMPORT_ASSETS_API = `${API_JWT_BASE_URL}/Assets/import`
export const DISCOVERED_ASSETS_API = `${API_JWT_BASE_URL}/Assets/discovered`
export const IMPORT_DISCOVERED_ASSETS_API = `${API_JWT_BASE_URL}/Assets/Devices`
export const IMPORT_SFE_KEYS_API = `${API_JWT_BASE_URL}/Assets/sfe/import`
export const UPDATE_SERVICE_HISTORY_API = `${API_JWT_BASE_URL}/Assets/ServiceHistories/`
export const ADD_SERVICE_HISTORY_API = `${API_JWT_BASE_URL}/Assets/ServiceHistories`
export const UPDATE_ASSET_ADDITIONAL_DETAILS_API = `${API_JWT_BASE_URL}/Assets/`

export const ASSETS_QUERY_KEYS = {
  SEARCH_ASSETS: 'SEARCH_ASSETS',
  GET_ASSET_DETAILS: 'GET_ASSET_DETAILS',
  EXPORT_ASSETS: 'EXPORT_ASSETS',
  IMPORT_ASSETS: 'IMPORT_ASSETS',
  DISCOVERED_ASSETS: 'DISCOVERED_ASSETS',
  IMPORT_DISCOVERED_ASSETS: 'IMPORT_DISCOVERED_ASSETS',
  UPDATE_SERVICE_HISTORY: 'UPDATE_SERVICE_HISTORY',
  IMPORT_SFE_KEYS_API: 'IMPORT_SFE_KEYS_API',
  ADD_SERVICE_HISTORY: 'ADD_SERVICE_HISTORY',
  UPDATE_ASSET_ADDITIONAL_DETAILS: 'UPDATE_ASSET_ADDITIONAL_DETAILS'
}
